import React from "react";
import ReactApexChart from "react-apexcharts";

function DotTrendChart({ chartData, chartOptions, height = "100%" }) {
  return (
    <ReactApexChart
      options={chartOptions}
      series={chartData}
      type="line"
      width="100%"
      height={height}
    />
  );
}

export default DotTrendChart;
